var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlert = function SvgAlert(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 396,
    height: 396,
    viewBox: "0 0 396 396",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M-342-762H738v1920H-342z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 198,
    r: 198,
    fill: "#ffffff",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120 93)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C5CCD3",
    fillRule: "nonzero",
    d: "M20.376 26.25C9.074 26.25 0 35.786 0 47.345v141.56C0 200.466 9.074 210 20.376 210h108.671c11.302 0 20.376-9.535 20.376-21.094V47.345c0-11.559-9.074-21.095-20.376-21.095H112.81a3.395 3.395 0 0 0-2.98 1.688 3.409 3.409 0 0 0 0 3.43 3.395 3.395 0 0 0 2.98 1.688h16.237c7.512 0 13.584 6.243 13.584 14.289v141.561c0 8.046-6.072 14.288-13.584 14.288H20.376c-7.512 0-13.584-6.242-13.584-14.288V47.345c0-8.046 6.072-14.29 13.584-14.29h16.25a3.395 3.395 0 0 0 2.982-1.686 3.409 3.409 0 0 0 0-3.431 3.395 3.395 0 0 0-2.982-1.688h-16.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CCD3",
    fillRule: "nonzero",
    d: "M74.712 0C63.6 0 54.519 8.95 54.519 19.904h-6.73c-7.4 0-13.462 5.976-13.462 13.27v9.951c0 1.832 1.507 3.317 3.365 3.317h74.039c1.858 0 3.365-1.485 3.365-3.317v-9.952c0-7.293-6.062-13.27-13.461-13.27h-6.718C94.917 8.952 85.837 0 74.725 0h-.013zm0 6.635c7.473 0 13.461 5.901 13.461 13.269a13.076 13.076 0 0 1-.276 2.644c-.205.975.046 1.99.683 2.764a3.385 3.385 0 0 0 2.604 1.226h10.438c3.787 0 6.73 2.902 6.73 6.635v6.635H41.046v-6.635c0-3.733 2.944-6.635 6.73-6.635H58.24a3.385 3.385 0 0 0 2.625-1.23c.641-.78.89-1.804.674-2.786a13.31 13.31 0 0 1-.302-2.63c.006-7.363 5.991-13.257 13.461-13.257h.014z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.721,
    cy: 19.183,
    r: 7.067,
    fill: "#C5CCD3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9EB2BD",
    fillRule: "nonzero",
    d: "M71.914 72.739c-11.01.493-21.88 4.908-30.27 13.247-17.833 17.72-17.832 46.56 0 64.28 17.832 17.722 46.852 17.722 64.684 0a45.204 45.204 0 0 0 12.414-22.758 3.365 3.365 0 0 0-1.019-3.276 3.415 3.415 0 0 0-3.376-.703 3.384 3.384 0 0 0-2.257 2.593c-1.5 7.098-5.012 13.848-10.568 19.369-15.235 15.14-39.837 15.14-55.073 0a38.482 38.482 0 0 1 0-54.729c14.337-14.247 36.983-15.057 52.284-2.507a3.415 3.415 0 0 0 4.786-.455 3.364 3.364 0 0 0-.458-4.757c-8.98-7.365-20.136-10.798-31.147-10.304zm39.91 22.997c-1.2-.02-2.322.59-2.952 1.606a3.36 3.36 0 0 0-.115 3.342 38.336 38.336 0 0 1 3.625 11.017c.311 1.84 2.065 3.08 3.917 2.77a3.38 3.38 0 0 0 2.788-3.892 45.055 45.055 0 0 0-4.262-12.943 3.4 3.4 0 0 0-3-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9EB2BD",
    d: "M95.425 100.962a3.371 3.371 0 0 0-2.304 1.053l-26.213 26.969-12.547-14.189a3.372 3.372 0 0 0-5.055 4.462l14.969 16.913a3.371 3.371 0 0 0 4.937.122l28.74-29.576a3.37 3.37 0 0 0-2.527-5.751v-.003z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlert);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alert.ee0bb6fc39fc6b55435ccbf0b678bd45.svg";